document.addEventListener("DOMContentLoaded", () => {
  // Track last tapped swatch for mobile double-tap navigation
  let lastTappedSwatch = null;

  // Check if device has no hover capability (touch-primary device)
  function isTouchDevice() {
    return window.matchMedia('(hover: none)').matches;
  }

  // Update product card images based on swatch selection
  function updateProductCardMedia(swatch) {
    const varImage = swatch.dataset.varimage;
    const varImageSet = swatch.dataset.varsrcset;
    const varSecImage = swatch.dataset.varsecimage;
    const varSecImageSrcset = swatch.dataset.varsecimageSrcset;
    const variantUrl = swatch.dataset.variantUrl;

    const parent = swatch.closest(".product-card-wrapper");
    if (!parent) return;

    const cardMedia = parent.querySelector(".card__media");
    const cardInner = parent.querySelector(".card__inner");

    if (cardMedia) {
      const Media = parent.querySelector(".media");
      const firstImage = Media.querySelector(".var-first-image");
      const secImage = Media.querySelector(".var-sec-image");

      if (firstImage) {
        firstImage.src = varImage;
        firstImage.srcset = varImageSet;
      }
      if (secImage) {
        // A colour without a second image has no data-varsecimage: show its
        // main image on hover instead of requesting "undefined".
        secImage.src = varSecImage || varImage;
        secImage.srcset = (varSecImage ? varSecImageSrcset : varImageSet) || "";
      }

      if (cardInner && variantUrl) {
        cardInner.setAttribute("href", variantUrl);
        cardInner.setAttribute("onclick", `goToProduct('${variantUrl}', 1)`);
      }
    }

    const titleLink = parent.querySelector(".card__heading a");
    if (titleLink && variantUrl) {
      titleLink.setAttribute("href", variantUrl);
    }

    // Mark this swatch as active
    parent.querySelectorAll(".card__swatches-each").forEach(s => s.classList.remove("active"));
    swatch.classList.add("active");
  }

  // Handle swatch click/tap
  function handleSwatchInteraction(event) {
    const swatch = event.target.closest(".card__swatches-each");
    if (!swatch) return;

    const variantUrl = swatch.dataset.variantUrl;
    if (!variantUrl) return;

    // Desktop: update images and navigate immediately
    if (!isTouchDevice()) {
      updateProductCardMedia(swatch);
      window.location.href = variantUrl;
      return;
    }

    // Mobile: double-tap to navigate
    if (lastTappedSwatch === swatch) {
      // Second tap on same swatch - navigate
      window.location.href = variantUrl;
      lastTappedSwatch = null;
    } else {
      // First tap or tap on different swatch - update images
      updateProductCardMedia(swatch);
      lastTappedSwatch = swatch;
    }
  }

  // Handle mouseover for desktop hover preview
  function handleSwatchHover(event) {
    if (isTouchDevice()) return;
    const swatch = event.target.closest(".card__swatches-each");
    if (swatch) {
      updateProductCardMedia(swatch);
    }
  }

  document.body.addEventListener("click", handleSwatchInteraction);
  if (document.body.classList.contains('template-collection')) {
    document.body.addEventListener("mouseover", handleSwatchHover);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Function to open the modal
  function openModal(modalContent) {
    document.querySelector(".c-modal-overlay").classList.add("active");
    modalContent.classList.add("active");
  }

  // Function to close the modal
  function closeModal(modalContent) {
    modalContent.classList.remove("active");
    document.querySelector(".c-modal-overlay").classList.remove("active");
  }

  // Event delegation for opening the modal
  document.body.addEventListener("click", function (event) {
    const target = event.target.closest("[data-info-popup-btn]");
    if (target) {
      const modalTarget = target.getAttribute("data-modal-target");
      const modalContent = document.querySelector('[data-modal-content="' + modalTarget + '"]');
      if (modalContent) {
        openModal(modalContent);
      }
      event.preventDefault();
    }
  });

  // Event delegation for closing the modal
  document.body.addEventListener("click", function (event) {
    if (event.target.matches("[data-modal-close]") || event.target.closest(".c-modal-overlay")) {
      event.preventDefault();
      const modalContent = document.querySelector('[data-modal-content].active');
      if (modalContent) {
        closeModal(modalContent);
      }
    }
  });
});

const search_input = document.querySelector("#Search-In-Modal");
const search_div = document.querySelector("#search-div");

search_input.addEventListener('input', () => {
  if (search_input.value) {
    search_div.style.display = 'none';
  } else {
    search_div.style.display = 'block';
  }
})

document.addEventListener('DOMContentLoaded', () => {
  // Select elements
  const modal = document.querySelector('#myModal'); // Modal element
  const closeModalBtn = document.querySelector('.close'); // Close button inside modal
  const html = document.documentElement; // Select the <html> element

  // Open modal
  function openModal() {
    modal.classList.add('open');
    html.style.overflow = 'hidden'; // Disable scrolling on <html>
    html.style.height = '100%'; // Ensure proper height handling
  }

  // Close modal
  function closeModal() {
    modal.classList.remove('open');
    html.style.overflow = ''; // Re-enable scrolling on <html>
    html.style.height = ''; // Reset height
  }

  // Close modal when clicking outside modal content
  if (modal) {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal();
      }
    });
  }

  // Close modal when clicking the close button
  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', closeModal);
  }
});


function initCustomSelect() {
  const selectEl = document.querySelector('.js-custom-select');
  if (!selectEl) return;

  const existingWrapper = selectEl.parentNode.querySelector('.custom-select-wrapper');
  if (existingWrapper) {
    return;
  }

  selectEl.style.display = 'none';

  const wrapper = document.createElement('div');
  wrapper.className = 'custom-select-wrapper';

  selectEl.parentNode.insertBefore(wrapper, selectEl.nextSibling);

  const styledSelect = document.createElement('div');
  styledSelect.className = 'custom-select-styled';
  styledSelect.textContent = selectEl.options[selectEl.selectedIndex].textContent;
  wrapper.appendChild(styledSelect);

  const dropdown = document.createElement('ul');
  dropdown.className = 'custom-select-dropdown';
  dropdown.style.display = 'none';
  wrapper.appendChild(dropdown);

  Array.from(selectEl.options).forEach((optionEl, index) => {
    const li = document.createElement('li');
    li.textContent = optionEl.textContent;
    li.dataset.value = optionEl.value;
    dropdown.appendChild(li);

    if (optionEl.selected) {
      li.classList.add('is-selected');
    }

    li.addEventListener('click', function() {
      selectEl.selectedIndex = index;

      const changeEvent = new Event('input', {bubbles: true});
      const submitEvent = new Event('submit', {bubbles: true});
      selectEl.dispatchEvent(changeEvent);
      document.querySelector('#FacetSortDrawerForm').dispatchEvent(submitEvent);

      styledSelect.textContent = optionEl.textContent;
      dropdown.querySelectorAll('li').forEach((x) => x.classList.remove('is-selected'));
      li.classList.add('is-selected');
      dropdown.style.display = 'none';
    });
  });

  const triggers = document.querySelectorAll('.js-caret, .facet-filters__field label');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function (e) {
      if (trigger.tagName.toLowerCase() === 'label') {
        e.preventDefault();
      }

      e.stopPropagation();
      if (dropdown.style.display === 'none') {
        closeAllCustomSelects();
        dropdown.style.display = 'block';
      } else {
        dropdown.style.display = 'none';
      }
    });
  });

  document.addEventListener('click', closeAllCustomSelects);

  function closeAllCustomSelects() {
    const allDropdowns = document.querySelectorAll('.custom-select-dropdown');
    allDropdowns.forEach(function(dd) {
      dd.style.display = 'none';
    });
  }
}


document.addEventListener('DOMContentLoaded', function() {
  initCustomSelect();
});
const container = document.querySelector('#ProductGridContainer')
    || document.querySelector('main');

if (container) {
  const observer = new MutationObserver((mutations) => {
    initCustomSelect();
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    characterData: false,
  });
}

document.querySelectorAll('.mega-menu__link').forEach(link => {
  if (link.getAttribute('href') === '#') {
    link.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent the default action
    });

    // Optionally, you can also add a class to indicate it's not clickable
    link.classList.add('disabled-link');
  }
});

// PLP Swatches Scroll Custom Element
if (!customElements.get('plp-swatches-scroll')) {
  customElements.define('plp-swatches-scroll', class PlpSwatchesScroll extends HTMLElement {
    constructor() {
      super();
      this.scrollContainer = null;
      this.leftArrow = null;
      this.rightArrow = null;
      this.resizeObserver = null;
      this.resizeTimeout = null;
      this.scrollRAF = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    connectedCallback() {
      this.scrollContainer = this.querySelector('[data-scroll-container]');
      this.leftArrow = this.querySelector('[data-arrow="prev"]');
      this.rightArrow = this.querySelector('[data-arrow="next"]');

      if (!this.scrollContainer) return;

      // A labelled group, not a focusable region: every swatch is already a
      // button and the focusin handler below scrolls the focused one into
      // view, so a tab stop on the scroller itself was an extra, empty stop
      // (and a region landmark per card is noise for screen readers).
      this.scrollContainer.setAttribute('role', 'group');
      this.scrollContainer.setAttribute('aria-label', 'Color swatches');

      this.updateArrows = this.updateArrows.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);

      this.bindEvents();
      this.setupResizeObserver();

      // Double RAF to ensure layout is fully calculated
      requestAnimationFrame(() => {
        requestAnimationFrame(this.updateArrows);
      });

      // Also check after load in case fonts/images affect layout
      if (document.readyState === 'complete') {
        setTimeout(this.updateArrows, 0);
      } else {
        window.addEventListener('load', this.updateArrows, { once: true });
      }
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF);
        this.scrollRAF = null;
      }
      window.removeEventListener('load', this.updateArrows);
    }

    bindEvents() {
      this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true });

      // Keep a keyboard-focused swatch within the visible part of the slider so
      // tabbing never lands focus on an off-screen swatch.
      this.scrollContainer.addEventListener('focusin', (e) => {
        const swatch = e.target.closest('.plp-swatch');
        if (!swatch || !this.scrollContainer.contains(swatch)) return;
        const containerRect = this.scrollContainer.getBoundingClientRect();
        const swatchRect = swatch.getBoundingClientRect();
        if (swatchRect.left < containerRect.left || swatchRect.right > containerRect.right) {
          swatch.scrollIntoView({
            inline: 'nearest',
            block: 'nearest',
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
          });
        }
      });

      this.scrollContainer.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.scrollBy(-this.getScrollAmount());
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.scrollBy(this.getScrollAmount());
        }
      });

      this.leftArrow?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.scrollBy(-this.getScrollAmount());
      });

      this.rightArrow?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.scrollBy(this.getScrollAmount());
      });
    }

    handleScroll() {
      if (this.scrollRAF) return;
      this.scrollRAF = requestAnimationFrame(() => {
        this.updateArrows();
        this.scrollRAF = null;
      });
    }

    handleResize() {
      if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        requestAnimationFrame(this.updateArrows);
      }, 100);
    }

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      this.resizeObserver.observe(this.scrollContainer);
    }

    getScrollAmount() {
      const swatch = this.scrollContainer.querySelector('.plp-swatch');
      return swatch ? (swatch.offsetWidth + 8) * 2 : 68;
    }

    scrollBy(amount) {
      const behavior = this.prefersReducedMotion ? 'auto' : 'smooth';
      this.scrollContainer.scrollBy({ left: amount, behavior });
    }

    updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const hasOverflow = scrollWidth > clientWidth;
      const canScrollLeft = scrollLeft > 1;
      const canScrollRight = scrollLeft < scrollWidth - clientWidth - 1;

      if (this.leftArrow) {
        this.leftArrow.hidden = !hasOverflow || !canScrollLeft;
        this.leftArrow.setAttribute('aria-disabled', String(!canScrollLeft));
      }
      if (this.rightArrow) {
        this.rightArrow.hidden = !hasOverflow || !canScrollRight;
        this.rightArrow.setAttribute('aria-disabled', String(!canScrollRight));
      }
    }
  });
}

/**
 * a11y: Keep the region-selector modal's `aria-hidden` in sync with its visibility.
 *
 * The region selector (snippets/modal.region-selector.liquid) is opened/closed by the
 * bundled modal system in layout.theme.js. That system wraps the content in a
 * `<div class="c-modal" data-modal="regionSelector">` and toggles the `is-visible`
 * class on that wrapper. The wrapper is hidden by being positioned OFF-SCREEN
 * (`.c-modal { bottom: 100% }`), NOT via `display:none`, so the content stays in the
 * accessibility tree while closed. We mirror visibility onto `aria-hidden` so screen
 * readers only see the dialog while it is actually on screen.
 */
document.addEventListener("DOMContentLoaded", function () {
  var MODAL_NAME = "regionSelector";

  // Sync aria-hidden on the region-selector content from its `.c-modal` wrapper state.
  function syncRegionSelectorAria() {
    var wrapper = document.querySelector('.c-modal[data-modal="' + MODAL_NAME + '"]');
    // The content keeps its data attribute after being wrapped/moved by the bundle.
    var content = document.querySelector('[data-modal-content="' + MODAL_NAME + '"]');
    if (!content) return;
    var isVisible = !!wrapper && wrapper.classList.contains("is-visible");
    content.setAttribute("aria-hidden", isVisible ? "false" : "true");
  }

  // The `.c-modal` wrapper is created lazily on first open and its `is-visible` class
  // is toggled on open/close, so observe the modal container for both.
  var container = document.querySelector("[data-modal-container]");
  if (container) {
    var observer = new MutationObserver(syncRegionSelectorAria);
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // Set the correct initial state (closed).
  syncRegionSelectorAria();
});


